class VideoMarquee extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));

    if (!('IntersectionObserver' in window)) return;

    const videos = this.querySelectorAll('.video-marquee__video');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    videos.forEach((video) => observer.observe(video));
  }

  onClick(event) {
    const button = event.target.closest('.video-marquee__mute');
    if (!button) return;
    event.preventDefault();

    const card = button.closest('.video-marquee__card');
    const video = card && card.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    const isUnmuted = !video.muted;
    button.classList.toggle('is-unmuted', isUnmuted);
    button.setAttribute('aria-pressed', String(isUnmuted));
    button.setAttribute('aria-label', isUnmuted ? 'Mute video' : 'Unmute video');
  }
}

customElements.define('video-marquee', VideoMarquee);
